import { Link } from '@tanstack/react-router'
import { Code2 } from 'lucide-react'

export default function Header() {
  return (
    <header className="p-4 flex flex-col items-center justify-center bg-gray-800 text-white shadow-lg gap-1">
      <Link
        to="/"
        className="text-3xl md:text-4xl font-bold font-['Montserrat',sans-serif] flex items-center gap-3 hover:opacity-90 transition-opacity"
        aria-label="HTML Editor"
      >
        <span className="inline-flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full border-3 border-[#ff694a] text-[#ff694a]">
          <Code2 size={24} className="md:w-8 md:h-8" />
        </span>
        HTML Editor
      </Link>
      <h1 className="text-base md:text-lg font-medium font-['Montserrat',sans-serif] text-gray-300 tracking-wide">
        Free Online WYSIWYG HTML Editor
      </h1>
    </header>
  )
}
